import { template, isFunction, endsWith } from 'lodash';
import * as constants from './constants';

export const defaultLocale = 'LV';

const localeCache = {};

function getLocale(locale) {
  if (Object.prototype.hasOwnProperty.call(localeCache, locale)) { return localeCache[locale]; }

  let strings;

  try {
    strings = require(`./strings.${locale}.js`).default;
  } catch (e) {
    if (locale !== defaultLocale) {
      /* eslint-disable no-console */
      console.warn(`Unable to load locale "${locale}". Loading default locale "${defaultLocale}" instead.`, e);
      /* eslint-enable no-console */
      return getLocale(defaultLocale);
    } else {
      throw new Error(`Unable to load default locale "${defaultLocale}"`);
    }
  }

  const templates = Object.keys(strings).reduce((o, k) => {
    o[k] = template(strings[k]);
    return o;
  }, {});

  const t = function localize(p) {
    if (!p) {
      return '__UNDEFINED';
    }

    if (!Object.prototype.hasOwnProperty.call(templates, p)) {
      return p;
    }

    const f = templates[p];
    if (!isFunction(f)) {
      return p;
    }

    return f.apply(f, [...arguments].slice(1));
  };

  t.exists = p => Object.prototype.hasOwnProperty.call(templates, p) && isFunction(templates[p]);

  t.__locale = locale;

  localeCache[locale] = t;

  return t;
}

export { constants };

let currentLocalize = { __locale: null };

export const initializeLocalization = (locale) => {
  currentLocalize = getLocale(locale);
};

export const getCurrentLocale = () => currentLocalize.__locale;
export const localizationExists = key => currentLocalize.exists(key);
export const localize = (...args) => {
  if (!currentLocalize) throw new Error('`initializeLocalization()` must be called before calling localize.');
  return currentLocalize(...args);
};



// WEBPACK FOOTER //
// ./src/translations/index.js